module.exports = __webpack_public_path__ + "assets/2ccac276d170d84ee4be036cf01280ce.mp3";